module.exports = {
  presets: ['babel-preset-expo'],
};
